import {
  ASSISTANT_LANGUAGE_OPTIONS,
  ASSISTANT_RESPONSE_OPTIONS,
  KEYBOARD_SHORTCUT_OPTIONS,
  LISTEN_FOR_OPTIONS,
} from '@/components/Settings/generalAssistantOptions'

export { ASSISTANT_LANGUAGE_OPTIONS, ASSISTANT_RESPONSE_OPTIONS, KEYBOARD_SHORTCUT_OPTIONS, LISTEN_FOR_OPTIONS }

export const GENERAL_ASSISTANT_INITIAL = {
  siaEnabled: true,
  listenFor: 'off',
  keyboardShortcut: 'cmd-s',
  language: 'en-gb',
  voiceLabel: 'American (Voice 5)',
  responses: 'silent',
}

export const GENERAL_ASSISTANT_ROWS = [
  { id: 'sia-enabled', title: 'Sia', description: '', control: 'toggle', stateKey: 'siaEnabled' },
  { id: 'listen-for', title: 'Listen for', description: '', control: 'dropdown', stateKey: 'listenFor', options: LISTEN_FOR_OPTIONS },
  { id: 'keyboard-shortcut', title: 'Keyboard shortcut', description: 'Press to type to Sia, hold to speak to Sia', control: 'dropdown', stateKey: 'keyboardShortcut', options: KEYBOARD_SHORTCUT_OPTIONS },
  { id: 'language', title: 'Language', description: '', control: 'dropdown', stateKey: 'language', options: ASSISTANT_LANGUAGE_OPTIONS },
  { id: 'responses', title: 'Sia responses', description: '', control: 'dropdown', stateKey: 'responses', options: ASSISTANT_RESPONSE_OPTIONS },
]
